import { useMediaQuery, useTheme } from '@material-ui/core'
import ExpandLessIcon from '@material-ui/icons/ExpandLess'
import { useState } from 'react'

import useStyles from './styles'

interface Props {}

export default function Index({}: Props) {
  const classes = useStyles()
  const [show, setShow] = useState(false)
  const theme = useTheme()
  const isSmall = useMediaQuery(theme.breakpoints.down('sm'))

  function topFunction() {
    return window.scrollTo({
      behavior: 'smooth',
      top: 0
    })
  }

  function scrollFunction() {
    if (
      (document.body.scrollTop > 40 ||
        document.documentElement.scrollTop > 40) &&
      !isSmall
    ) {
      setShow(true)
    } else if (
      (document.body.scrollTop > 3 * window.innerHeight ||
        document.documentElement.scrollTop > 3 * window.innerHeight) &&
      isSmall
    ) {
      setShow(true)
    } else {
      setShow(false)
    }
  }

  window.onscroll = function () {
    scrollFunction()
  }

  return (
    <div
      className={[
        classes.root,
        isSmall ? classes.rootForMobileSize : '',
        show ? classes.show : ''
      ].join(' ')}
      onClick={topFunction}>
      <ExpandLessIcon
        className={[
          classes.icon,
          isSmall ? classes.iconForMobileSize : ''
        ].join(' ')}
      />
    </div>
  )
}
